"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var PromoCodeTemplateCountryEditor = /** @class */ (function (_super) {
    __extends(PromoCodeTemplateCountryEditor, _super);
    function PromoCodeTemplateCountryEditor(props) {
        return _super.call(this, props) || this;
    }
    PromoCodeTemplateCountryEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            app_country_id: 0,
            app_country_title: ""
        }, function () {
            _this.props.state.setExtBreadCrumbPath(["Шаблоны промокода", "Добавить страну шаблона промокода"]);
        });
        this.doReSetRules();
    };
    PromoCodeTemplateCountryEditor.prototype.doReSetRules = function () {
        this.setState({
            app_country_rules: { isError: false }
        });
    };
    PromoCodeTemplateCountryEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_country_id <= 0) || (this.state.app_country_title.length === 0)) {
            this.setState({ app_country_rules: { isError: true, errorMessage: "Страна не выбрана!" } });
            return false;
        }
        return true;
    };
    PromoCodeTemplateCountryEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_country_id: this.state.app_country_id,
                promocode_template_id: this.props.rootRecord.key,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Страна шаблона промокода добавлена!");
            });
        }
    };
    PromoCodeTemplateCountryEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PromoCodeTemplateCountryEditor.prototype.getFormTitle = function () {
        return "Добавить страну шаблона промокода";
    };
    PromoCodeTemplateCountryEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 290 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Страна:", placeholder: "Выберите страну" }, value: { key: this.state.app_country_id, value: this.state.app_country_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_country_id: newVal.key,
                        app_country_title: newVal.value,
                        app_country_rules: { isError: false }
                    });
                }, items: this.props.availCountry, required: true, rules: this.state.app_country_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: false, title: { btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this) })));
    };
    return PromoCodeTemplateCountryEditor;
}(React.Component));
exports.default = PromoCodeTemplateCountryEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_promocodes/ui/component/countries/PromoCodeTemplatesCountriesEdit.tsx
// module id = 1968
// module chunks = 0